import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import { Translate } from 'react-localize-redux';

import Grid from '@components/basics/grid';
import Pill from '@components/basics/pill';
import Flex from '@components/layout/flex';
import { getWidth } from '@components/styles';
import Typography from '@components/basics/typography';
import SquareCover from '@components/basics/square-cover';
import CatalogTrack from '@common/types/catalog/catalog-track';

interface CatalogReleaseInfoSidebarProps {
  className?: string;
  releaseCover: string;
  releaseTitle: string;
  // TODO: DEVTEAM-603 - tracks needs to use the correct type.
  tracks?: CatalogTrack[];
  isNFT?: boolean;
  nftType?: string;
}

const CatalogReleaseInfoSidebar: FunctionComponent<
  CatalogReleaseInfoSidebarProps
> = ({ className, releaseCover, releaseTitle, tracks, isNFT, nftType }) => {
  return (
    <Grid className={className || ''} gap={30}>
      <Flex justifyContent="space-between" alignItems="center" gap={10}>
        <Flex alignItems="center" gap={10}>
          <SquareCover
            className="artwork"
            size={32}
            borderRadius={4}
            src={releaseCover}
            alt={releaseTitle}
          />
          <Typography weight="700">{releaseTitle}</Typography>
        </Flex>
        {/* TODO: DEVTEAM-603 - This needs to be integrated with the type of NFT that it is. */}
        {isNFT && nftType && <Pill>{nftType}</Pill>}
      </Flex>
      {tracks && (
        <Grid gap={20}>
          <Typography customFont="medium" type="title" weight="500">
            <Translate id="RELEASE.SIDEBAR.LIST.TRACKLIST" />
          </Typography>
          {/* TODO: DEVTEAM-603 - This is for demo only, we need to integrate the current tracks from the release. */}
          {tracks.map((track) => (
            <Flex key={track.name} alignItems="center" gap={10}>
              <Typography type="small-circle-black">
                {track.order < 10 ? `0${track.order}` : track.order}
              </Typography>
              <Typography weight="700">{track.name}</Typography>
            </Flex>
          ))}
        </Grid>
      )}
    </Grid>
  );
};

export default styled(CatalogReleaseInfoSidebar)`
  margin-bottom: 20px;
  width: 100%;

  .artwork {
    flex-shrink: 0;
  }

  @media ${({ theme }) => theme.device.laptopS} {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 32px;
    max-width: ${getWidth(5)};
  }
  @media ${({ theme }) => theme.device.laptopLM} {
    left: 0;
  }
`;
